// src/pages/Home/Home.js
import React from 'react';
// import Showcase from '@/components/Home/Showcase';
import Eyecatch from '../../components/Home/Eyecatch';
import Showcase from '../../components/Home/Showcase';
import About from '../../components/Home/About';
// import styles from './Home.module.css';

function Home() {
  return (
    <div>
      <Eyecatch />
      <Showcase />
      <About />
    </div>
  );
}

export default Home;
